define('services/worldEdge',[], function () {
    'use strict';
    function splitOnEdgeOfTheWorld(bBox) {
        if (!bBox) {
            return [];
        }
        if (bBox.minLon < -180) {
            return [
                {minLon: -180, minLat: bBox.minLat, maxLon: bBox.maxLon, maxLat: bBox.maxLat},
                {minLon: 360 + bBox.minLon, minLat: bBox.minLat, maxLon: 180, maxLat: bBox.maxLat}
            ];
        }
        if (bBox.maxLon > 180) {
            return [
                {minLon: bBox.minLon, minLat: bBox.minLat, maxLon: 180, maxLat: bBox.maxLat},
                {minLon: -180, minLat: bBox.minLat, maxLon: bBox.maxLon - 360, maxLat: bBox.maxLat}
            ];
        }
        return [bBox];
    }

    function responseCollector(numBoundingBoxes, responses, callback, model) {
        return function (response) {
            responses = responses || [];
            responses.push(response);
            if (responses.length === (numBoundingBoxes || 1)) {
                responses = responses.length === 1 ? responses[0] : responses;
                callback(model(responses));
            }
        };
    }

    return function (service, model, data, callback, addBoundingBoxParameters) {
        var boundingBoxes = splitOnEdgeOfTheWorld(data.boundingBox),
            responses = [];
        data.boundingBox = null;
        for (var i = 0; i < (boundingBoxes.length || 1); i += 1) {
            data = boundingBoxes[i] ? addBoundingBoxParameters(data, boundingBoxes[i]) : data;
            service(data, responseCollector(boundingBoxes.length, responses, callback, model));
        }
    };
});

